import { render } from "./CajaList.vue?vue&type=template&id=427789f3&scoped=true"
import script from "./CajaList.vue?vue&type=script&lang=js"
export * from "./CajaList.vue?vue&type=script&lang=js"

import "./CajaList.vue?vue&type=style&index=0&id=427789f3&scoped=true&lang=scss"

import exportComponent from "C:\\laragon\\www\\frontend_restaurante\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-427789f3"]])

export default __exports__